import { Widget } from './form-widget.model';
import { TextProperty } from './properties/text-property.model';
import { PropertyBase } from './properties/property-base.model';
import { BooleanValueProperty } from './properties/boolean-property.model';

export class CheckboxItemProperties {
  public properties: any;
  constructor(data: any = {}) {
    const properties = {
      text: new TextProperty({
        title: data.text.title,
        value: data.text.value,
      }),
      value: new TextProperty({
        title: data.value.title,
        value: data.value.value,
      }),
    };
    this.properties = properties;
  }
}

export class CheckboxCompositeItemsProperties extends PropertyBase {
  constructor(data: any = {}) {
    super(data);
    this.title = data.title || 'Value';
    //this.type = data.type || 'select-multiple';
    this.value = [];
    data.value.forEach((item) => {
      this.value.push(<any>new CheckboxItemProperties(item.properties));
    });
  }
}

export class FbCheckboxCompositeWidget extends Widget {
  constructor(data: any = {}) {
    super(data);

    this.title = 'Single Choice';
    this.name = 'fb-checkbox-composite';
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(data: any = {}) {
    const properties = {
      required: new BooleanValueProperty(data.required || { title: 'Required' }),
      text: new TextProperty({
        value: data.text ? data.text.value : 'Multi Choice',
      }),
      content: new TextProperty(data.content || { title: 'Description' }),
      value: new CheckboxCompositeItemsProperties(data.value),
      columns: new TextProperty({
        title: 'Columns',
        value: data.columns ? +data.columns.value : 1,
      }),
    };
    return properties;
  }

  isValid() {
    if (!this.isRequired()) {
      return true;
    }

    return this.properties.value.value.filter((item) => item.properties.value.value > 0).length > 0;
  }

  validate() {
    if (!this.isValid()) {
      return false;
    }
    return true;
  }
}
